import { ApplicationModel } from "@/models/pipeline";
import * as React from "react";

type RowProps = {
  id: string | number;
  children: React.ReactNode;
  data: ApplicationModel;
  step?: string;
};

export const Row: React.FC<RowProps> = ({ children }) => {
  return <tr className="border-b border-solid border-slate-200">{children}</tr>;
};
